import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { white } from '@styles/colors';
import { Box, Grid, Stack, Typography } from '@mui/material';
import OnboardingCompanyList from '../../features/applications/components/EnterpriseDigitalOnboarding/OnboardingCompanyList';
import EnterpriseOnboardingDocumnets from '../../features/applications/components/EnterpriseDigitalOnboarding/EnterpriseOnboardingDocumnets';

function EnterpriseOnboarding() {
    const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>();
    const [companyPlan, setCompanyPlan] = useState<number>(0);
    return (
        <>
            <Helmet>
                <title>Digital Onboarding | StaffedUp</title>
            </Helmet>
            <Stack component="section" spacing={5} pt={5} pb={4} px={3} pl={6}>
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={3}
                    bgcolor={white}
                    p={3}
                    borderRadius={8}
                    alignItems="center"
                >
                    <Typography variant="h3" fontSize="28px" fontWeight="bold">
                        Digital Onboarding
                    </Typography>
                    <Stack spacing={3} direction="row"></Stack>
                </Stack>
                <Grid container>
                    <Grid item xs={12} md={3} pr={{ xs: 0, sm: 3 }} pb={{ xs: 3, sm: 0 }}>
                        <OnboardingCompanyList
                            selectedCompanyId={selectedCompanyId}
                            setSelectedCompanyId={setSelectedCompanyId}
                            setCompanyPlan={setCompanyPlan}
                        />
                    </Grid>
                    <Grid item xs={12} md={9}>
                        {selectedCompanyId ? (
                            <EnterpriseOnboardingDocumnets
                                selectedCompanyId={selectedCompanyId}
                                companyPlan={companyPlan}
                            />
                        ) : (
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                height="100vh"
                                textAlign="center"
                                bgcolor={white}
                                width='100%'
                                borderRadius={8}
                            >
                                <Typography variant="h6" fontSize="28px" fontWeight="bold">
                                    Please select a company
                                </Typography>
                            </Box>
                        )}

                    </Grid>
                </Grid>
            </Stack>
        </>
    );
}

export default EnterpriseOnboarding;
